import React, {Fragment, Suspense} from 'react';
import '../../Legacy/assets/legacy.css';
import LegacyFrame from "../../Legacy/LegacyFrame";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import requestApi from "../../../services/requestApi.service";
import {handleErrorResponse} from "../../../Common/Appcommon";
class LegacyEmailParser extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mailContent : '',
        }
    
    }
    componentDidMount = async() => {
        let params = {
            "ENTITY": "EmailScanner",
            "OPERATION" : "getServername",
            "isOtherApiReq" : true,
        }

        let responseData = await requestApi.processServerRequest(params,"WebV2","post");
        if(responseData.issuccess && responseData.data !== undefined){
            this.setState({
                mailContent : responseData.data
            })
        }else{
            if(responseData.errormsg !== "") {
                handleErrorResponse(responseData.errormsg);
            }
        }
        
    }
    render() {
        let mainContent = this.state.mailContent;
        return (
            <>
                <div className={'cursor-pointer ml-2 emailparser-back'} onClick={(e) => {this.props.onBackAction(e)}}>
                    <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                </div>
                {mainContent[1] == 'Administrator' && mainContent[0] != undefined && mainContent[0] != '' && <div className='emailparserdiv'><span className='emailparserspan1'>Mail Forward To:</span><span className='emailparserspan2'> {`${mainContent[0]}@mailbox.cratiocrm.com`}</span></div>}
                <LegacyFrame withHeader={false} pageTitle={"Email Parser"} formname={"table_30"} customClass={"field-customization-container"} />
            </>
        );
    }
}

export default LegacyEmailParser;
